export default __webpack_public_path__ + "static/media/S40.b3b2fbd5.png";